<template>
  <div class="wrap contact">
    <global-header is-error></global-header>

    <div class="content has-error container-fluid">
      <!-- タブボタン部分 -->
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a href="#tab1" class="nav-link active" data-toggle="tab">エラー</a>
        </li>
      </ul>

      <!--タブのコンテンツ部分-->
      <div class="tab-content">
        <div id="tab1" class="tab-pane active">
          <p>{{ loginUserErrorMessage }}</p>
          <div class="btn_error mt20">
            <a
              href="#"
              class="btn btn-lg btn-primary"
              @click.prevent="logoutHandler"
              >ログイン画面へ</a
            >
          </div>
        </div>
        <!-- 発注確定 -->
      </div>

      <global-footer></global-footer>
    </div>
  </div>
</template>

<script>
import { store as loginUser } from "../store/LoginUser";

export default {
  computed: {
    loginUserErrorMessage() {
      return loginUser.errorMessage;
    }
  },

  methods: {
    async logoutHandler() {
      const response = await this.postAsteria("Login", "logout");

      if (response.responseData.return != 0) {
        if (response.responseData.return != 9) {
          window.alert("ログアウトに失敗しました");
        }
        return;
      }

      // this.submitAsteria("", "", {}, "", "/");
      this.linkToLogin();
    }
  }
};
</script>
